import { render, staticRenderFns } from "./Scheme.vue?vue&type=template&id=e3bf54be&scoped=true"
import script from "./Scheme.vue?vue&type=script&lang=js"
export * from "./Scheme.vue?vue&type=script&lang=js"
import style0 from "./Scheme.vue?vue&type=style&index=0&id=e3bf54be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3bf54be",
  null
  
)

export default component.exports